import { Component, inject } from '@angular/core';
import { TerminalSessionResponse } from '../../pts-payment-terminal-model';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { PtsPaymentTerminalService } from 'src/app/shared/services/payment-terminal.service';
import { FeedbackInfoComponent, SnackbarService } from 'ok-angular-shared/components';
import { HttpErrorResponse } from '@angular/common/http';
import { DkCurrencyPipe } from '../../../../../shared/pipes/dk-currency';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'adm-revert-reserved-amount',
  templateUrl: './revert-reserved-amount-dialog.component.html',
  styleUrl: './revert-reserved-amount-dialog.component.scss',
  imports: [DkCurrencyPipe, FeedbackInfoComponent, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton, MatIcon],
})
export class RevertReservedAmountDialogComponent {
  dialogRef = inject<MatDialogRef<RevertReservedAmountDialogComponent>>(MatDialogRef);
  data = inject<{
    terminalSession: TerminalSessionResponse;
  }>(MAT_DIALOG_DATA);
  private ptsPaymentTerminalService = inject(PtsPaymentTerminalService);
  private snackbarService = inject(SnackbarService);

  terminalSession: TerminalSessionResponse = this.data.terminalSession;
  revertReservedAmountError: RevertReservedAmountError | null;

  public revertReservedAmount() {
    this.ptsPaymentTerminalService.revertReservedAmount(this.terminalSession).subscribe({
      next: () => {
        this.snackbarService.success('Det reservede beløb blev frigivet');
        this.dialogRef.close(this.terminalSession);
      },
      error: (err: HttpErrorResponse) => {
        if (err.error.code === 30024) {
          this.snackbarService.error('Det er ikke muligt at frigive det reserverede beløb, da sessionen ikke har den korrekte status');
        } else {
          this.snackbarService.error(`Der skete fejl under frigivelse af det reserverede beløb (${err.error.code})`);
        }
        this.revertReservedAmountError = err.error;
        setTimeout(() => {
          if (this.revertReservedAmountError) {
            this.revertReservedAmountError.show = true;
          }
        }, 500);
      },
    });
  }

  public close() {
    this.dialogRef.close();
  }
}

export class RevertReservedAmountError {
  constructor() {
    this.show = false;
  }
  code: number;
  message: string;
  show: boolean;
}
